import { render, staticRenderFns } from "./MainCharts.vue?vue&type=template&id=5d2d6590&scoped=true"
import script from "./MainCharts.vue?vue&type=script&lang=js"
export * from "./MainCharts.vue?vue&type=script&lang=js"
import style0 from "./MainCharts.vue?vue&type=style&index=0&id=5d2d6590&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d6590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2d6590')) {
      api.createRecord('5d2d6590', component.options)
    } else {
      api.reload('5d2d6590', component.options)
    }
    module.hot.accept("./MainCharts.vue?vue&type=template&id=5d2d6590&scoped=true", function () {
      api.rerender('5d2d6590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/MainCharts.vue"
export default component.exports